import {mergeAttributes, Node} from "@tiptap/core";
import {ReactNodeViewRenderer} from "@tiptap/react";
import PrintoutQrCodeNodeView from "./PrintoutQrCodeNodeView";
import {
    clampPrintoutQrCodeSizeMm,
    DEFAULT_PRINTOUT_QR_CODE_SIZE_MM,
    getPrintoutQrCodeAttrs,
} from "./printoutQrCodeOptions";
import type {PrintoutQrCodeNodeAttrs} from "./printoutQrCodeOptions";

export const PrintoutQrCodeNode = Node.create({
    name: "printoutQrCode",

    group: "block",
    atom: true,
    selectable: true,
    draggable: true,

    addAttributes() {
        return {
            url: {
                default: null,
                parseHTML: element => element.getAttribute("data-printout-qr-code-url"),
                renderHTML: attributes => attributes.url
                    ? {"data-printout-qr-code-url": attributes.url}
                    : {},
            },
            sizeMm: {
                default: DEFAULT_PRINTOUT_QR_CODE_SIZE_MM,
                parseHTML: element => clampPrintoutQrCodeSizeMm(element.getAttribute("data-printout-qr-code-size-mm")),
                renderHTML: attributes => ({
                    "data-printout-qr-code-size-mm": clampPrintoutQrCodeSizeMm(attributes.sizeMm),
                }),
            },
        };
    },

    parseHTML() {
        return [
            {
                tag: 'div[data-type="printout-qr-code"]',
            },
        ];
    },

    renderHTML({HTMLAttributes, node}) {
        const attrs = getPrintoutQrCodeAttrs(node.attrs as PrintoutQrCodeNodeAttrs);
        const frameStyle = `width:${attrs.sizeMm}mm;height:${attrs.sizeMm}mm`;

        return [
            "div",
            mergeAttributes(HTMLAttributes, {
                "data-type": "printout-qr-code",
                class: "printout-rendered-qr-code-block",
            }),
            ["div", {class: "printout-qr-code-frame", style: frameStyle}],
        ];
    },

    addNodeView() {
        return ReactNodeViewRenderer(PrintoutQrCodeNodeView, {
            trackNodeViewPosition: true,
        });
    },
});
